import * as angular from 'angular';
import { ClassificationCategoriesService } from '../../../app.retailer.common/modules/categories/classification-categories.service';
import { IChoiceCategoriesTreeOptions } from '../../../app.retailer.common/modules/categories/select-classification-categories-tree/select-classification-categories-tree.component';
import { IChoiceClassificationCategoriesOptions } from '../../../app.retailer.common/modules/categories/select-classification-categories/select-classification-categories.component';
import { AccountService } from '../account/account.service';
import { CategoryListItem, ClassificationCategoryListItem } from '../core';

export class CategoriesSelectorService {
    public static $inject = ['$uibModal',  'classificationCategoriesService', 'accountService'];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
        private classificationCategoriesService: ClassificationCategoriesService,
        private accountService: AccountService
    ) { }

    public selectClassificationCategoriesTree = (excludedIDs: number[], selectedIDs: number[], showPrices: boolean, leafOnly: boolean, singleSelect: boolean): angular.IPromise<ClassificationCategoryListItem[]> => {
        return this.$uibModal.open({
            component: 'selectClassificationCategoriesTree',
            size: 'md',
            windowClass: 'categories-selector-popup',
            resolve: {
                options: (): IChoiceCategoriesTreeOptions => {
                    return {
                        showPrices,
                        excludedIDs,
                        selectedIDs,
                        leafOnly,
                        singleSelect,
                        recentlyUsedCategories: []
                    };
                },
                languageId: (): number => {
                    return  this.accountService.userData.languageID;
                }
            }
        }).result;
    }
    public selectClassificationCategories = (selectedCategories: CategoryListItem[], businessType: number, singleSelect: boolean, isOnlyStoreCategories?: boolean, subcategoryId?: number): angular.IPromise<CategoryListItem[]> => {
        return this.$uibModal.open({
            component: 'selectClassificationCategories',
            size: 'lg',
            resolve: {
                options: (): IChoiceClassificationCategoriesOptions => {
                    return {
                        singleSelect,
                        selectedCategories,
                        businessType,
                        isOnlyStoreCategories,
                        subcategoryId
                    };
                },
                languageId: (): number => {
                    return  this.accountService.userData.languageID;
                }
            }
        }).result;
    }
}

angular.module('naut').service('categoriesSelectorService', CategoriesSelectorService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/categories/categoriesSelector.service.ts